import { render, staticRenderFns } from "./StandardCheckout.vue?vue&type=template&id=efd6fbb8&scoped=true&"
import script from "./StandardCheckout.vue?vue&type=script&lang=js&"
export * from "./StandardCheckout.vue?vue&type=script&lang=js&"
import style0 from "./StandardCheckout.vue?vue&type=style&index=0&id=efd6fbb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd6fbb8",
  null
  
)

export default component.exports